import React from "react";

const SUPPORT_EMAIL = "travinov@gmail.com";

export function SupportPage({
  theme,
  cardStyle,
  onNavigate,
}: {
  theme: "light" | "dark";
  cardStyle: React.CSSProperties;
  onNavigate: (to: string) => void;
}) {
  const linkStyle: React.CSSProperties = {
    color: "#0f8c57",
    fontWeight: 700,
    textDecoration: "none",
  };

  const muted: React.CSSProperties = {
    color: theme === "dark" ? "#9fb3d1" : "#5a6776",
    fontSize: 13,
    lineHeight: 1.45,
  };

  return (
    <div style={{ display: "grid", gap: 16, paddingTop: 10 }}>
      <div style={{ display: "grid", gap: 6 }}>
        <div style={{ fontSize: 22, fontWeight: 900, letterSpacing: -0.3 }}>Support</div>
        <div style={muted}>
          SplitwiseKiller is a simple expense splitting app (friends and groups). If you have any issues or questions,
          contact us using the email below.
        </div>
      </div>

      <div style={{ ...cardStyle, display: "grid", gap: 10 }}>
        <div style={{ fontWeight: 900, fontSize: 16 }}>Contact</div>
        <div style={muted}>
          Email:{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`} style={linkStyle}>
            {SUPPORT_EMAIL}
          </a>
        </div>
        <div style={muted}>We typically respond within 1 to 2 business days.</div>
        <div style={muted}>
          Privacy Policy:{" "}
          <a href="/privacy" style={linkStyle}>
            splitwisekiller.com/privacy
          </a>
        </div>
      </div>

      <div style={{ ...cardStyle, display: "grid", gap: 10 }}>
        <div style={{ fontWeight: 900, fontSize: 16 }}>For TestFlight Review</div>
        <div style={muted}>
          If you are reviewing a TestFlight build and need assistance accessing content (for example, joining a group),
          please email us and include:
        </div>
        <ul style={{ margin: 0, paddingLeft: 18, ...muted }}>
          <li>your Apple ID email used for TestFlight</li>
          <li>the app version/build number</li>
          <li>a short description of what you tried and what happened</li>
        </ul>
      </div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <button
          type="button"
          onClick={() => onNavigate("/")}
          style={{
            padding: "10px 12px",
            borderRadius: 12,
            border: theme === "dark" ? "1px solid #273244" : "1px solid #dde4ec",
            background: theme === "dark" ? "#0e1116" : "#ffffff",
            color: theme === "dark" ? "#e7ecf3" : "#111",
            fontWeight: 800,
            cursor: "pointer",
          }}
        >
          Back to app
        </button>
      </div>
    </div>
  );
}
